'use strict';

exports = module.exports = interval;
function interval(delay, fn) {
  var start = Date.now();
  var data = {};
  data.id = requestAnimationFrame(loop);

  return data;

  function loop() {
    data.id = requestAnimationFrame(loop);

    if (Date.now() - start >= delay) {
      fn();
      start = Date.now();
    }
  }
}


exports.clear = clearInterval;
function clearInterval(data) {
  cancelAnimationFrame(data.id);
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/request-interval/index.js
// module id = 5O6M
// module chunks = 0